module.exports = __webpack_public_path__ + "img/csr_032423_B.389e7be7.jpg";